import React from 'react';
import { Form } from 'react-bootstrap';

const FrequencySelector = ({ frequency, setFrequency }) => {
  return (
    <div className="d-flex justify-content-between align-items-center mb-2">
      <Form.Label htmlFor="repeat-select" className="fw-bold text-white mb-1 mb-0">
        Frequency
      </Form.Label>
      <Form.Select
        id="frequency-select"
        value={frequency}
        onChange={(e) => setFrequency(e.target.value)}
        className="bg-dark text-white border-secondary w-auto"
        style={{ minWidth: 180 }}
      >
        <option value="day">Day</option>
        <option value="week">Week</option>
        <option value="month">Month</option>
        <option value="year">Year</option>
      </Form.Select>
    </div>
  );
};

export default FrequencySelector;
